var React = require('react');

function ArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.89785 4.22305C8.65957 4.59033 8.66481 5.67331 7.90668 6.04794L1.5337 9.19715C0.860797 9.52967 0.0721659 9.04235 0.0685338 8.29178L0.0383545 2.05518C0.0347224 1.30461 0.818601 0.809675 1.49469 1.13566L7.89785 4.22305Z","fill":"#A5A9AF"}));
}

ArrowIconInline.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = ArrowIconInline;

ArrowIconInline.default = ArrowIconInline;
